//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 export default {
    name:'sm-header',
    props:{
        leftTxt:{
            type: String,
            default: '返回'
        },
        title: {
            type: String,
            default: null
        },
        rightTxt: {
            type: String,
            default: null
        },
        isFixed: {
            type: Boolean,
            default: true
        },
        smHleftEvent: {
            type: Function,
            default: function() {
                return console.log('点击header左侧')
            }
        },
        smHrightEvent: {
            type: Function,
            default: function() {
                return console.log('点击header右侧')
            }
        }
    },
}



// WEBPACK FOOTER //
// ./node_modules/smart_webview_ui/src/components/sm_header/sm_header.vue